// extracted by mini-css-extract-plugin
module.exports = {"base":"TranslationMessages_base__34bTO"};